module.exports = __webpack_public_path__ + "static/media/icon-cancel-booking.a7140288.svg";